module.exports = {"141033100":"蒲城镇","141033101":"薛关镇","141033102":"黑龙关镇","141033103":"克城镇","141033200":"山中乡","141033201":"古县乡","141033202":"红道乡","141033203":"乔家湾乡","141033204":"太林乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141033.json
// module id = 332
// module chunks = 0